import React from "react";

import { API_ENDPOINT } from "../../../constants/appConstant";
import { useNetwork } from "../../../hooks/useNetwork";
import { ApopProps } from "../../../types";
import { LanguagesType } from "../common/LanguageCard/Language.types";
import { Events } from "../common/json/clevertapEvents";
import { BasicDetailsUI } from "./BasicDetailsUI";

interface UpdatedData {
  [key: string]: any;
}

export const BasicDetailsApop = ({
  prefilledData,
  nextApopType,
  onCTA,
  toast,
  closeApop,
  flowType,
  eventName,
  handleEventTracking,
  jobData,
}: ApopProps) => {
  const { fetchData: fetchAPI } = useNetwork();
  const { response: apiResponse, fetchData: submitFetchApi } = useNetwork();

  const onSubmit = async (
    data: any,
    isOtherCity: boolean,
    siteMap: string,
    languageData?: LanguagesType[],
  ) => {
    const updatedData: UpdatedData = {
      fullName: data.name,
      additionalPersonalDetail: {
        experience: {
          years: data.years.id,
          months: data.months.id,
        },
        currentLocation: {
          id: data.city.id,
          text: data.city.text,
        },
      },
      experienceLevel:
        data.years.text === "0" && data.months.text === "0"
          ? "FRESHER"
          : "EXPERIENCED",
    };

    if (isOtherCity) {
      updatedData["additionalPersonalDetail"]["currentLocation"]["text"] =
        data.city.text;
      updatedData["additionalPersonalDetail"]["currentLocation"]["otherText"] =
        data.otherCity;
    }

    if (siteMap !== "monstersingapore") {
      updatedData["additionalPersonalDetail"]["gender"] = {
        id: data.gender.id,
        text: data.gender.text,
      };
    }

    if (data.nationality) {
      updatedData["nationality"] = {
        id: data.nationality.id,
        text: data.nationality.text,
      };
    }

    if (data.workAuthorization) {
      if (data?.workAuthorization?.id !== "0") {
        updatedData["additionalPersonalDetail"]["workVisaType"] = {
          id: data.workAuthorization.id,
          text: data.workAuthorization.text,
        };
      }
      if (data?.city?.countryUUID !== data?.nationality?.countryUUID) {
        updatedData["additionalPersonalDetail"]["workVisaTypeUpdated"] = true;
      }
    }

    if (data.linkedin) {
      handleEventTracking({
        eventType: "eventPush",
        eventName: Events["LINKED_IN"]?.linkedInClick?.["EVENTNAME"],
        eventProps: Events["LINKED_IN"]?.linkedInClick?.["EVENTOBJ"],
      });
      updatedData["socialPresence"] = {
        url: data.linkedin,
        name: "LinkedIn",
      };
    }

    if (data.isToggled) {
      updatedData["profileAutoUpdate"] = {
        linkedInConsent: true,
      };
    } else {
      updatedData["profileAutoUpdate"] = {
        linkedInConsent: false,
        reason: "OTHER_REASONS",
      };
    }

    if (siteMap !== "rexmonster" && languageData && languageData.length > 0) {
      updatedData["languages"] = languageData;
    }

    eventName && (updatedData["eventName"] = eventName);

    handleEventTracking({
      eventType: "eventPush",
      eventName: Events["BASIC_DETAILS"].submitEvent["EVENTNAME"],
      eventProps: Events["BASIC_DETAILS"].submitEvent["EVENTOBJ"],
    });

    const res = await submitFetchApi(
      `${API_ENDPOINT().seekerProfile.workExperienceMiddleware}`,
      "POST",
      {},
      updatedData,
    );

    onCTA && onCTA("BASIC_DETAILS");

    if (res.data) {
      const nextAction = (res.data as any)?.nextActionRequired?.actionType;
      if (flowType === "PROFILE_NUDGE" && !nextAction) {
        const nextNudgeRes = await fetchAPI(
          `${API_ENDPOINT().seekerProfile.nextNudge}`,
          "GET",
        );

        if (nextNudgeRes.data) {
          const profileNudgeActionType = (nextNudgeRes.data as any)?.actionType;

          onCTA && onCTA("MOBILE_OTP");
          toast &&
            toast({
              showToast: true,
              text:
                (res.data as any).successMessage ??
                "Section updated successfully",
              type: "success",
            });
          // data is inside rest.data for profile nudge flow
          nextApopType(
            profileNudgeActionType,
            (nextNudgeRes.data as any)?.data,
          );
        } else {
          toast({
            showToast: true,
            text: "Something went wrong! Please try again.",
            type: "error",
          });
        }
      } else {
        nextApopType(
          nextAction ?? "",
          (res.data as any)?.nextActionRequired ?? null,
        );

        toast({
          showToast: true,
          text:
            (res.data as any)?.successMessage ?? "Section updated successfully",
          type: "success",
        });
      }

      if (data.linkedin) {
        handleEventTracking({
          eventType: "eventPush",
          eventName: Events["LINKED_IN"].linkedInAdded["EVENTNAME"],
          eventProps: Events["LINKED_IN"].linkedInAdded["EVENTOBJ"],
        });
      }
    } else {
      toast({
        showToast: true,
        text:
          (res.error as any)?.error?.message?.errorMessage ??
          "Something went wrong",
        type: "error",
      });
    }
  };

  return (
    <BasicDetailsUI
      prefilledData={prefilledData}
      closeApop={closeApop}
      onSubmit={onSubmit}
      isSubmitAPILoading={apiResponse.isLoading}
      flowType={flowType}
      jobData={jobData}
    />
  );
};
